<template>
    <div>
        <timeline :time-line-items="steps" :active-index="0">
            <template v-slot:form>
                <Card>
                    <template v-slot:title>Newsletter</template>
                    <div class="checkbox-inline">
                        <label class="checkbox checkbox-primary">
                            <input name="newsletter" type="radio"
                                   value="true"
                                   v-model="form.newsletter">
                            <span></span>{{ __('account-setup.newsletter.subscribe') }}
                        </label>
                    </div>
                    <div class="checkbox-inline">
                        <label class="checkbox checkbox-primary">
                            <input name="newsletter"
                                   type="radio"
                                   value="false"
                                   v-model="form.newsletter">
                            <span></span>{{ __('account-setup.newsletter.dont_subscribe') }}
                        </label>
                    </div>
                </Card>

                <div class="d-flex justify-content-end mt-12">
                    <button @click="previousStep" class="mr-auto py-4 btn btn-secondary">
                        <i class="fas fa-arrow-circle-left mr-3"></i>{{ __('actions.back') }}
                    </button>
                    <button @click="submit()" class="btn btn-primary">
                        {{ __('actions.next') }}<i class="fas fa-arrow-circle-right ml-3"></i>
                    </button>
                </div>

            </template>
        </timeline>
    </div>
</template>

<script>
import Card from '@components/Cards/Card';
import Timeline from '@components/Timeline';
import AccountSetupLayout from '@layouts/AccountSetupLayout';

export default {
    components: {Timeline, Card},

    layout: AccountSetupLayout,

    props: {
        steps: Object,
        newsletter: false,
    },

    data() {
        return {
            form: this.$inertia.form({
                newsletter: false,
            }),
        };
    },

    mounted() {
        this.form.newsletter = this.newsletter;
    },

    methods: {
        submit() {
            this.form.post(this.$route('account-setup-newsletter.update'), {
                onError: () => {
                    toastr.error(__('general.error_check_data'))
                },
                onSuccess:() => {
                    toastr.success(__('account-setup.thing.success', {thing: __('account-setup.newsletter.settings')}))
                }
            });
        },

        previousStep() {
            return this.$inertia.get(this.$route('account-setup.show'));
        },
    },
};
</script>
